var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailoredWaitPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 48,
    height: 48,
    rx: 5,
    transform: "rotate(90 54 0)",
    fill: "#00C6A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 15.3333C30.2762 15.3333 30.5001 15.5572 30.5001 15.8333V24C30.5001 24.2761 30.2762 24.5 30.0001 24.5H24.7501C24.4739 24.5 24.2501 24.2761 24.2501 24C24.2501 23.7239 24.4739 23.5 24.7501 23.5H29.5001V15.8333C29.5001 15.5572 29.7239 15.3333 30.0001 15.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4167 27C36.6929 27 36.9167 27.2239 36.9167 27.5V28.75H38.7501C39.0262 28.75 39.2501 28.9739 39.2501 29.25C39.2501 29.5261 39.0262 29.75 38.7501 29.75H36.4167C36.1406 29.75 35.9167 29.5261 35.9167 29.25V27.5C35.9167 27.2239 36.1406 27 36.4167 27Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9172 15.2956C22.1184 12.6389 25.4636 10.6667 30.0001 10.6667C36.0428 10.6667 39.8376 14.5594 41.7501 17.4729V14.0833C41.7501 13.8072 41.9739 13.5833 42.2501 13.5833C42.5262 13.5833 42.7501 13.8072 42.7501 14.0833V19.3333C42.7501 19.6095 42.5262 19.8333 42.2501 19.8333H36.4167C36.1406 19.8333 35.9167 19.6095 35.9167 19.3333C35.9167 19.0572 36.1406 18.8333 36.4167 18.8333H41.414C39.8149 16.0467 36.1446 11.6667 30.0001 11.6667C25.7865 11.6667 22.7151 13.4861 20.6872 15.9336C18.6477 18.395 17.6667 21.4902 17.6667 24C17.6667 26.5097 18.6477 29.605 20.6872 32.0664C22.7151 34.5139 25.7865 36.3333 30.0001 36.3333C30.2762 36.3333 30.5001 36.5572 30.5001 36.8333C30.5001 37.1095 30.2762 37.3333 30.0001 37.3333C25.4636 37.3333 22.1184 35.3611 19.9172 32.7044C17.7275 30.0617 16.6667 26.7402 16.6667 24C16.6667 21.2597 17.7275 17.9383 19.9172 15.2956Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4167 33.5C38.764 33.5 40.6667 31.5972 40.6667 29.25C40.6667 26.9028 38.764 25 36.4167 25C34.0695 25 32.1667 26.9028 32.1667 29.25C32.1667 31.5972 34.0695 33.5 36.4167 33.5ZM36.4167 34.5C39.3162 34.5 41.6667 32.1495 41.6667 29.25C41.6667 26.3505 39.3162 24 36.4167 24C33.5173 24 31.1667 26.3505 31.1667 29.25C31.1667 32.1495 33.5173 34.5 36.4167 34.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 24C60 27.3137 57.3137 30 54 30C50.6863 30 48 27.3137 48 24C48 20.6863 50.6863 18 54 18C57.3137 18 60 20.6863 60 24Z",
    fill: "#9088DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 29C56.7614 29 59 26.7614 59 24C59 21.2386 56.7614 19 54 19C51.2386 19 49 21.2386 49 24C49 26.7614 51.2386 29 54 29ZM54 30C57.3137 30 60 27.3137 60 24C60 20.6863 57.3137 18 54 18C50.6863 18 48 20.6863 48 24C48 27.3137 50.6863 30 54 30Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 27.3137 9.31371 30 6 30C2.68629 30 0 27.3137 0 24C0 20.6863 2.68629 18 6 18C9.31371 18 12 20.6863 12 24Z",
    fill: "#9088DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 29C8.76142 29 11 26.7614 11 24C11 21.2386 8.76142 19 6 19C3.23858 19 1 21.2386 1 24C1 26.7614 3.23858 29 6 29ZM6 30C9.31371 30 12 27.3137 12 24C12 20.6863 9.31371 18 6 18C2.68629 18 0 20.6863 0 24C0 27.3137 2.68629 30 6 30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredWaitPreview);
export default __webpack_public_path__ + "static/media/TailoredWaitPreview.7225fa9177f4d9718fce7ba49830e9d2.svg";
export { ForwardRef as ReactComponent };